import { z } from 'zod';

import {
    sessionGenerate,
    sessionResolveAction,
    sessionSchedule,
    sessionUpdate,
} from '@nesso/session-contracts/session.commands';
import { treatmentApproachesSchema } from '@nesso/session-contracts/session.models';
import {
    getClientActivity,
    getClientServiceCodes,
    getSessionList,
} from '@nesso/session-contracts/session.queries';

import { MAX_SELECTED_APPROACHES } from '../config/session.config';

export const generateSessionOutputSchema = sessionGenerate.output;
export const scheduleSessionOutputSchema = sessionSchedule.output;
export const getClientServiceCodesOutputSchema = getClientServiceCodes.output;
export {
    clientActivityItemSchema,
    sessionListItemSchema,
} from '@nesso/session-contracts/session.queries';

export const getSessionListOutputSchema = getSessionList.output;
export const getClientActivityOutputSchema = getClientActivity.output;
export {
    inputMethodSchema,
    sessionActionsSchema,
    sessionSchema,
} from '@nesso/session-contracts/session.models';
export { noteGeneratorProgressNotificationSchema } from '@nesso/session-contracts/session-note.generator-notifications';
export {
    generationStatusSchema,
    sessionNoteStatusSchema,
    sessionNoteTypeSchema,
} from '@nesso/session-contracts/session-note.models';

export const generateSessionInputSchema = sessionGenerate.input.omit({
    practiceId: true,
    practiceMemberId: true,
});

export const updateSessionInputSchema = sessionUpdate.input.omit({
    practiceMemberId: true,
});

export const resolveActionInputSchema = sessionResolveAction.input.omit({
    practiceMemberId: true,
});

export const scheduleSessionInputSchema = sessionSchedule.input.omit({
    practiceId: true,
    practiceMemberId: true,
});

export const generateNotesSchema = z.object({
    treatmentApproaches: treatmentApproachesSchema
        .min(1, 'Select at least 1 treatment approach')
        .max(MAX_SELECTED_APPROACHES, `Select up to ${MAX_SELECTED_APPROACHES} approaches`),
});
